import dayjs from "dayjs";
import { DynamicGroupTypes } from "../../../constants/enums";

/**
 * Centralized simple rules and helpers.
 */

export const requiredRule = (message = "This field is required") => ({
  required: true,
  message,
});

export const nonEmptyRule = (message = "Field cannot be only spaces") => ({
  pattern: /\S+/,
  message,
});

/**
 * Returns an async validator function that calls the provided searchFn.
 * searchFn should be a function like searchGroupIdentifier(type, [value]) -> Promise(action)
 */
export const displayNameAsyncValidator = (searchFn) => {
  return async (_, value) => {
    const v = (value && value.trim()) || "";
    if (!v) {
      return Promise.reject(
        new Error(
          "The Group display name cannot be empty or start with a space."
        )
      );
    }

    // searchFn is expected to return an action-like object with payload.data array
    const resp = await searchFn("DisplayName", [v]);
    const data = resp?.payload?.data || [];
    const found = data.find((o) => o.value === v);
    if (found && found.isTaken) {
      return Promise.reject(
        new Error("The Group display name is already taken!")
      );
    }
    return Promise.resolve();
  };
};

/**
 * Map server group object into antd form initialValues (dates -> dayjs)
 */
export const mapGroupToInitialValues = (group = {}) => {
  const copy = { ...group };
  if (group.validityLimit) copy.validityLimit = dayjs(group.validityLimit);
  if (group.blockingDeadline)
    copy.blockingDeadline = dayjs(group.blockingDeadline);
  // ensure booleans/checkboxes exist
  if (typeof copy.removeNonActiveMembers === "undefined")
    copy.removeNonActiveMembers = false;
  if (
    typeof copy.dynamicGroupType === "undefined" ||
    copy.dynamicGroupType === DynamicGroupTypes.Dynamic
  ) {
    copy.checkboxDynamicGroupType = false;
  } else copy.checkboxDynamicGroupType = true;
  return copy;
};
